<template>
  <div class="box p-5" style="border-radius: 10px">
    <div class="is-mobile mb-0 is-flex is-flex-direction-column">
      <div class="is-flex is-flex-direction-row is-align-items-center">
        <span
          style="height: 100%; font-size: 18px"
          class="has-text-primary has-text-weight-bold"
        >
          {{ achievement.title }}
        </span>
        <button
          v-if="is_editable"
          v-on:click="$emit('edit_achievement')"
          class="button is-primary is-light px-4 ml-3"
        >
          <span class="icon">
            <i class="far fa-edit"></i>
          </span>
        </button>
        <button
          v-if="is_editable"
          v-on:click="$emit('delete_achievement')"
          class="button is-danger is-light px-4 ml-3"
        >
          <span class="icon">
            <i class="fas fa-trash"></i>
          </span>
        </button>
      </div>
      <div class="">
        <span style="height: 100%" class="has-text-weight-bold is-italic">
          {{ achievement.associated_with }}
        </span>
        <span class="ml-3">{{ achievement.issue_date }}</span>
      </div>
    </div>

    <div style="height: 1px; background: #e5e5e5" class="my-2"></div>

    <div class="is-mobile mb-0 is-flex is-flex-direction-column">
      {{ achievement.details }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    is_editable: {
      type: Boolean,
      default: false,
    },
    achievement: {
      type: Object,
      // Keys: Title, Organization, Start Date, [End Date], [Details]
    },
  },
  emits: ['edit_achievement', 'delete_achievement'],
};
</script>
